import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { HeaderModule } from "src/app/ui-widgets/header/header.module";
import { ProductFiltersModule } from "src/app/ui-widgets/product-filters/product-filters.module";
import { ProductPaginationModule } from "src/app/ui-widgets/product-pagination/product-pagination.module";
import { ProductReviewsModule } from "src/app/ui-widgets/product-reviews/product-reviews.module";
import { SidebarModule } from "src/app/ui-widgets/sidebar/sidebar.module";
import { SafetyShoesRoutingModule } from "./safety-shoes-routing.module";
import { SafetyShoesDetailsComponent } from "./safety-shoes-details/safety-shoes-details.component";
import { SafetyShoesComponent } from "./safety-shoes.component";
import { ProductAttributesComponent } from "src/app/ui-widgets/product-attributes/product-attributes.component";
import { ProductAttributeIconListComponent } from "src/app/ui-widgets/product-attributes/product-attribute-icon-list/product-attribute-icon-list.component";
import { NgbCollapse } from "@ng-bootstrap/ng-bootstrap";

@NgModule({
    imports: [
    RouterModule,
    ProductFiltersModule,
    CommonModule,
    HeaderModule,
    SidebarModule,
    ProductPaginationModule,
    ProductReviewsModule,
    SafetyShoesRoutingModule,
    ProductAttributesComponent,
    ProductAttributeIconListComponent,
    NgbCollapse
],
    declarations: [
        SafetyShoesComponent,
        SafetyShoesDetailsComponent
    ]
})
  export class SafetyShoesModule { }
